import { render, staticRenderFns } from "./BatchGLPosting.vue?vue&type=template&id=6bd64838&scoped=true&"
import script from "./BatchGLPosting.vue?vue&type=script&lang=js&"
export * from "./BatchGLPosting.vue?vue&type=script&lang=js&"
import style0 from "./BatchGLPosting.vue?vue&type=style&index=0&id=6bd64838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd64838",
  null
  
)

export default component.exports